import { Button } from '@components/button';
import { Stack } from '@components/stack';
import { Text } from '@components/text';
import { useScopedTranslate } from '@locale/translate';

import { useChangePasswordModal } from './change-password-modal';

export const Password = () => {
  const { t } = useScopedTranslate(locale);

  const showPasswordModal = useChangePasswordModal();

  return (
    <Stack orientation="horizontal" justify="space-between">
      <div>
        <Text font="bold16" text={t('password')} />
        <Text font="regular14" color="textSecondary" text={t('setUniquePassword')} />
      </div>
      <Button variant="secondary" text={t('changePassword')} onClick={showPasswordModal} />
    </Stack>
  );
};

export const locale = {
  en: {
    password: 'Password',
    setUniquePassword: 'Set a unique password to protect your account',
    changePassword: 'Change password',
  },
  is: {
    password: 'Lykilorð',
    setUniquePassword: 'Settu einstakt lykilorð til að vernda aðganginn þinn',
    changePassword: 'Breyta lykilorði',
  },
};
